import React, { useState } from "react";


import {
  FaTruck,
  FaChevronDown,
  FaChevronUp,
  FaCheck,
} from "react-icons/fa";

function LogisticsSupplyChainPage() {
  const [openIndex, setOpenIndex] = useState(null);

  const toggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const sections = [
    {
      title: "Fleet & Transport",
      points: [
        "Route Optimization Agent",
        "Driver Fatigue Detection Agent",
        "Fuel Efficiency Agent",
        "Real-Time Vehicle Tracking Agent",
        "Predictive Maintenance for Fleet Agent",
      ],
    },

    {
      title: "Inventory & Warehousing",
      points: [
        "Inventory Replenishment Agent",
        "Stockout Risk Prediction Agent",
        "Dynamic Warehouse Layout Agent",
        "Shelf Life Monitoring Agent",
        "Warehouse Robot Coordinator Agent",
      ],
    },

    {
      title: "Procurement & Planning",
      points: [
        "Vendor Rating Agent",
        "Procurement Fraud Detection Agent",
        "Price Forecast Agent",
        "Automated Purchase Order Agent",
        "Smart Supplier Matching Agent",
      ],
    },

    {
      title: "Analytics & Visibility",
      points: [
        "Control Tower Monitoring Agent",
        "Real-time ETA Prediction Agent",
        "Cross-Docking Agent",
        "Customs Document Preparation Agent",
        "Carbon Emission Tracker Agent",
      ],
    },

    {
      title: "Customer & Experience",
      points: [
        "Shipment Status Notification Agent",
        "Reverse Logistics Agent",
        "Smart Rerouting in Transit Agent",
        "SLA Violation Detector Agent",
        "Returns & Refund Processing Agent",
      ],
    },
  ];

  return (
    <>

      {/* Responsive styles for this page */}
      <style>{`
        .logistics-wrapper {
          background: #22c7b8;
          min-height: 100vh;
        }

        .logistics-hero {
          background: #173b8f;
          width: 100%;
        }

        .logistics-hero-inner {
          width: 92%;
          max-width: 1300px;
          margin: 0 auto;
          padding: 38px 0px;
        }

        .logistics-hero-top {
          display: flex;
          align-items: center;
          gap: 12px;
          margin-bottom: 16px;
        }

        .logistics-icon-box {
          width: 44px;
          height: 44px;
          background: #22c7b8;
          border-radius: 10px;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
        }

        .logistics-icon-box svg {
          color: #ffffff;
          font-size: 20px;
        }

        .logistics-title {
          color: #ffffff;
          font-size: 34px;
          font-weight: 700;
          margin: 0;
          font-family: "Exo", sans-serif;
          word-break: break-word;
        }

        .logistics-description {
          color: #f2f2f2;
          font-size: 15px;
          line-height: 1.9;
          max-width: 1000px;
          margin: 0;
        }

        .logistics-accordion-wrap {
          width: 92%;
          max-width: 1050px;
          margin: 0 auto;
          padding: 28px 0px 50px;
        }

        .logistics-card {
          background: #ffffff;
          border-radius: 8px;
          margin-bottom: 10px;
          overflow: hidden;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
        }

        .logistics-card-header {
          padding: 14px 18px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          cursor: pointer;
          transition: 0.3s;
          gap: 10px;
        }

        .logistics-card-header.active {
          background: #173b8f;
        }

        .logistics-card-header.inactive {
          background: #ffffff;
        }

        .logistics-card-title {
          margin: 0;
          font-size: 16px;
          font-weight: 700;
          font-family: "Exo", sans-serif;
          word-break: break-word;
        }

        .logistics-card-title.active {
          color: #ffffff;
        }

        .logistics-card-title.inactive {
          color: #173b8f;
        }

        .logistics-chevron-active {
          color: #ffffff;
          font-size: 16px;
          flex-shrink: 0;
        }

        .logistics-chevron-inactive {
          color: #173b8f;
          font-size: 16px;
          flex-shrink: 0;
        }

        .logistics-card-content {
          padding: 18px 24px;
          background: #ffffff;
        }

        .logistics-point-row {
          display: flex;
          align-items: center;
          gap: 12px;
          margin-bottom: 12px;
        }

        .logistics-point-check {
          width: 24px;
          height: 24px;
          min-width: 24px;
          border-radius: 50%;
          background: #22c7b8;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
        }

        .logistics-point-check svg {
          color: #ffffff;
          font-size: 10px;
        }

        .logistics-point-text {
          margin: 0;
          color: #4b5563;
          font-size: 15px;
          line-height: 1.7;
          font-weight: 500;
          word-break: break-word;
        }

        /* Tablets */
        @media (max-width: 1024px) {
          .logistics-hero-inner {
            padding: 32px 0px;
          }

          .logistics-title {
            font-size: 30px;
          }

          .logistics-accordion-wrap {
            width: 90%;
          }
        }

        /* Small tablets / large phones */
        @media (max-width: 768px) {
          .logistics-hero-inner {
            width: 90%;
            padding: 26px 0px;
          }

          .logistics-icon-box {
            width: 40px;
            height: 40px;
          }

          .logistics-icon-box svg {
            font-size: 18px;
          }

          .logistics-title {
            font-size: 26px;
          }

          .logistics-description {
            font-size: 14px;
            line-height: 1.8;
          }

          .logistics-accordion-wrap {
            width: 90%;
            padding: 22px 0px 40px;
          }

          .logistics-card-header {
            padding: 12px 16px;
          }

          .logistics-card-title {
            font-size: 15px;
          }

          .logistics-card-content {
            padding: 16px 18px;
          }
        }

        /* Mobile phones */
        @media (max-width: 480px) {
          .logistics-hero-inner {
            width: 88%;
            padding: 22px 0px;
          }

          .logistics-hero-top {
            gap: 10px;
            margin-bottom: 12px;
          }

          .logistics-icon-box {
            width: 36px;
            height: 36px;
            border-radius: 8px;
          }

          .logistics-icon-box svg {
            font-size: 16px;
          }

          .logistics-title {
            font-size: 21px;
          }

          .logistics-description {
            font-size: 13px;
            line-height: 1.7;
          }

          .logistics-accordion-wrap {
            width: 90%;
            padding: 18px 0px 32px;
          }

          .logistics-card {
            border-radius: 6px;
            margin-bottom: 8px;
          }

          .logistics-card-header {
            padding: 10px 14px;
          }

          .logistics-card-title {
            font-size: 14px;
          }

          .logistics-card-content {
            padding: 14px 14px;
          }

          .logistics-point-row {
            gap: 10px;
            margin-bottom: 10px;
          }

          .logistics-point-check {
            width: 20px;
            height: 20px;
            min-width: 20px;
          }

          .logistics-point-check svg {
            font-size: 9px;
          }

          .logistics-point-text {
            font-size: 13.5px;
            line-height: 1.6;
          }
        }

        /* Very small phones */
        @media (max-width: 360px) {
          .logistics-title {
            font-size: 18px;
          }

          .logistics-card-title {
            font-size: 13px;
          }

          .logistics-point-text {
            font-size: 13px;
          }
        }
      `}</style>

      <div className="logistics-wrapper">
        {/* HERO SECTION */}
        <div className="logistics-hero">
          <div className="logistics-hero-inner">
            <div className="logistics-hero-top">
              <div className="logistics-icon-box">
                <FaTruck />
              </div>

              <h1 className="logistics-title">Logistics & Supply Chain</h1>
            </div>

            <p className="logistics-description">
              Covers the movement, storage, and tracking of goods from origin to consumption. AI agents optimize delivery routes, warehouse operations, demand forecasting, inventory management, and real-time shipment tracking.
            </p>
          </div>
        </div>

        {/* ACCORDION SECTION */}
        <div className="logistics-accordion-wrap">
          {sections.map((section, index) => {
            const isActive = openIndex === index;
            return (
              <div key={index} className="logistics-card">
                {/* HEADER */}
                <div
                  onClick={() => toggle(index)}
                  className={`logistics-card-header ${
                    isActive ? "active" : "inactive"
                  }`}
                >
                  <h2
                    className={`logistics-card-title ${
                      isActive ? "active" : "inactive"
                    }`}
                  >
                    {section.title}
                  </h2>

                  {isActive ? (
                    <FaChevronUp className="logistics-chevron-active" />
                  ) : (
                    <FaChevronDown className="logistics-chevron-inactive" />
                  )}
                </div>

                {/* CONTENT */}
                {isActive && (
                  <div className="logistics-card-content">
                    {section.points.map((point, i) => (
                      <div key={i} className="logistics-point-row">
                        <div className="logistics-point-check">
                          <FaCheck />
                        </div>

                        <p className="logistics-point-text">{point}</p>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
}

export default LogisticsSupplyChainPage;
